/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

interface Props {
  idOportunidade: string;
  IdCorretorDestino365: string;
  NomeCorretorDestino365: string;
}

export function useCompartilharOportunidade() {
  const postData = async (props: Props) => {
    const COMPARTILHAR_OPORTUNIDADE = `${backofficeEnviroment}/common/oportunidades-lead/compartilhar-oportunidade/v1`;
    const { data } = await instance.post(COMPARTILHAR_OPORTUNIDADE, {
      IdOportunidade365: props.idOportunidade,
      IdCorretorDestino365: props.IdCorretorDestino365,
      NomeCorretorDestino365: props.NomeCorretorDestino365,
    });
    return data;
  };

  const mutation = useMutation(postData, {
    onSuccess: () => {
      toast.success("Proposta compartilhada com sucesso!");
    },
    onError: (error: any) => {
      toast.error(
        `Erro ao compartilhar oportunidade. Motivos: ${error.response.data.notifications.map(
          (item: any) => item?.message
        )} `,
        { autoClose: 10000 }
      );
    },
  });

  return mutation;
}
